import { Link } from 'react-router-dom';
import '../styles/fonts.css';
import '../styles/team_detail.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Ranking from '../components/Ranking';
import TopStreams from '../components/TopStreams';
import UpcomingEvents from '../components/UpcomingEvents';

function TeamDetail() {
  return (
    <div className="TeamDetailPage">
      <Header />

      <main>
        <section id="hero-banner">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">Gerencie sua liga de SimRacing</h1>
              <p className="hero-sub">
                Resultados, classificações e painel do organizador — tudo em um só lugar.
              </p>
            </div>
            <div className="hero-actions">
              <Link to="/add-league" className="hero-btn-primary">
                Adicionar minha liga
              </Link>
              <Link to="/leagues" className="hero-btn-secondary">
                Ver ligas
              </Link>
            </div>
          </div>
        </section>

        <div className="content-grid">
          <aside className="left-col">
            <Ranking />
            <TopStreams />
          </aside>

          <section className="center-col team-detail">
            <div className="team-banner-header">
              <div className="team-identity">
                <div className="team-logo-display"></div>
                <div className="team-info-text">
                  <nav className="breadcrumb">
                    <Link to="/teams">Equipes</Link> &gt; <span>TopOne Motorsport</span>
                  </nav>
                  <h1>TopOne Motorsport</h1>
                  <p className="team-stats-summary">
                    Brasil | <i className="fas fa-calendar-alt"></i> Desde 2022 | <i className="fas fa-trophy"></i> 4 Títulos
                  </p>
                </div>
              </div>
              <div className="team-social-links">
                <a href="#" title="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="#" title="Twitter"><i className="fab fa-twitter"></i></a>
                <a href="#" title="Site Oficial"><i className="fas fa-globe"></i></a>
              </div>
            </div>

            <div className="team-lineup">
              <div className="box-header">
                <h3>Line-up de Pilotos</h3>
              </div>

              <div className="pilots-grid">
                <Link to="/pilots/1" className="pilot-card-square">
                  <div className="pilot-photo-box"></div>
                  <div className="pilot-data">
                    <span className="p-name">Max Verstappen</span>
                    <span className="p-irating">iRating: 9200</span>
                    <span className="p-country">🇳🇱 Holanda</span>
                  </div>
                </Link>
                <Link to="/pilots/2" className="pilot-card-square">
                  <div className="pilot-photo-box"></div>
                  <div className="pilot-data">
                    <span className="p-name">Tony Kanaan</span>
                    <span className="p-irating">iRating: 8500</span>
                    <span className="p-country">🇧🇷 Brasil</span>
                  </div>
                </Link>
              </div>
            </div>
          </section>

          <aside className="right-col">
            <section className="course-banner">
              <h3>Simracing sem Segredos</h3>
              <p>Aprenda a pilotar com quem entende do assunto.</p>
              <a href="#" className="btn-course">Conhecer Curso</a>
            </section>
            <UpcomingEvents />
          </aside>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default TeamDetail;